import React, { useState, useEffect, useRef, Component } from 'react';
import Box from '@mui/material/Box';
import Checkbox from '@mui/material/Checkbox';
import { red, green } from '@mui/material/colors';
import DeleteIcon from '@mui/icons-material/Delete';
import CircularProgress from '@mui/material/CircularProgress';
import { useDispatch } from "react-redux";
import LoadingPageIndicator from '../../../../../components/LoadingPageIndicator';
import { useParams } from "react-router";

import EditIcon from '@mui/icons-material/Edit';
import Paper from '@mui/material/Paper';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import Alert from '@mui/material/Alert';
import Divider from '@mui/material/Divider';
import Button from '@mui/material/Button';
import Typography from "@mui/material/Typography";
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import IconButton from '@mui/material/IconButton';
import TextField from '@mui/material/TextField';
import SaveIcon from '@mui/icons-material/Save';
import Fab from '@mui/material/Fab';
import { Questionnaire, Question} from '../../../../../models';
import Spacer from '../../../../../components/Spacer';


import Api, { ViewRequest } from '../../../../../api/medAppApi';
import { removeFromIndex } from '../../../../../helpers';
import { putMessage } from '../../../../app/store/actions';
import { useQuery } from 'react-query';
import queryClient from '../../../../../queryClient';


type QuestionType = {
    question: Question;
    index: number;
    selected: boolean;

    onSave: () => void;
    onSelect: (q: QuestionComponent) => void;
    onRemove?: (index: number) => void;
};

// const QuestionComponent: QuestionType = ({question, index, onChange}) => {
//     const [answerType, setAnswerType] = useState<string>(question.answerType);
//     const [questionText, setQuestionText] = useState(question.question);
//     const [placeholder, setPlaceholder] = useState(question.placeholder);
//     const [optional, setOptional] = useState(question.isOptional);
//     const [multiline, setMultiline] = useState(question.isMultiline);


//     const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
//       setAnswerType((event.target as HTMLInputElement).value);
//     };


// }


class QuestionComponent extends Component<QuestionType, Question & { changed: boolean; isEditing: boolean; }> {
    constructor(props: QuestionType) {
        super(props);
        this.state = {
            ...props.question,
            changed: false,
            isEditing: props.index === 0
        }

    }

    handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        this.setState(
            {
                ...this.state,
                answerType: ((event.target as HTMLInputElement).value) as ("number" | "boolean" | "string"),
                changed: true,
            }
        )
        this.selectThis()
    };

    getQuestion() {
        return ({
            question: this.state,
            index: this.props.index
        })
    }
    selectThis = () => {
        if (!this.props.selected) {
            this.props.onSelect(this)

        }
    }

    reset = (q: Question) => {
        this.setState({
            ...q,
            changed: false,
            isEditing: true
        })
    }

    _getBody = () => {
        if (this.state.answerType === 'string') {
            return (
                <TextField value={this.state.placeholder}
                    multiline={this.state.isMultiline} disabled variant="standard" fullWidth label="Answer" />

            )

        } else if (this.state.answerType === 'number') {
            return (
                <TextField value={"0"}
                    disabled variant="standard" type={'number'} fullWidth label="Answer" />

            )
        } else {
            return (
                <List sx={{
                    width: '100%',
                    bgcolor: 'background.paper'
                }} >
                    <ListItem disablePadding>
                        <ListItemButton>
                            <ListItemText primary={"Unanswered"} secondary="User did not answer question" />
                        </ListItemButton>
                    </ListItem>

                    <ListItem disablePadding>
                        <ListItemButton>
                            <ListItemText primary={"Yes"} secondary="User gave a positive answer" />
                        </ListItemButton>
                    </ListItem>

                    <ListItem disablePadding>
                        <ListItemButton>
                            <ListItemText primary={"No"} secondary="User gave a negative answer" />
                        </ListItemButton>
                    </ListItem>
                </List>
            )
        }

    }

    render() {
        if (this.state.isEditing) {
            return (
                <Paper style={{
                    padding: '1em',
                    width: '95%',
                    maxWidth: '700px',
                    minWidth: '200px',
                    marginBottom: '1em'
                }}>
                    <Typography component={'h6'} variant='h6'>{this.props.index === 0 ? "Edit question" : ("Question " + this.props.index)}</Typography>
                    <TextField value={this.state.question} onChange={(e) => {
                        this.setState({
                            ...this.state,
                            question: e.target.value as string,
                            changed: true,
                        })

                        this.selectThis();


                    }} multiline variant="standard" fullWidth label="Question" id={"question-" + this.props.index} />
                    <Spacer space={20} />


                    <FormControl component="fieldset">
                        <FormLabel component="legend">Answer Type</FormLabel>
                        <RadioGroup value={this.state.answerType} row aria-label="Answer Type" name="row-radio-buttons-group" onChange={this.handleChange} id={'answer-type-' + this.props.index}>
                            <FormControlLabel value="string" control={<Radio />} label="Text" />
                            <FormControlLabel value="number" control={<Radio />} label="Numerical" />
                            <FormControlLabel value="boolean" control={<Radio />} label="Yes or No" />
                        </RadioGroup>
                    </FormControl>
                    <Spacer space={20} />

                    <TextField disabled={this.state.answerType !== "string"} value={this.state.placeholder} onChange={(e) => {
                        this.setState({
                            ...this.state,
                            placeholder: e.target.value as string, changed: true,
                        })
                        this.selectThis();
                    }} fullWidth label="Question" id={"placeholder-" + this.props.index} />
                    <Spacer space={20} />
                    <FormControlLabel control={<Checkbox checked={this.state.isOptional} id={'is-optional-' + this.props.index} onChange={(e, c) => {
                        this.setState({
                            ...this.state,
                            isOptional: c,
                            changed: true,
                        });
                        this.selectThis()


                    }} ></Checkbox>} label="This is an optional question" />

                    <Spacer space={10} />
                    <FormControlLabel control={<Checkbox checked={this.state.isMultiline} id={'is-multiline-' + this.props.index} onChange={(e, c) => {
                        this.setState({
                            ...this.state,
                            isMultiline: c,
                            changed: true,
                        });
                        this.selectThis()
                    }} ></Checkbox>} label="This is question is not a one line question" />
                    <Spacer space={20} />
                    <Button disabled={!this.state.changed} style={{
                        marginRight: '1em'
                    }} onClick={() => {
                        this.setState({
                            ...this.state,
                            changed: false,
                            isEditing: this.props.index === 0
                        })
                        this.props.onSave()
                    }}>
                        Save
                    </Button>



                </Paper >
            )
        }

        else {
            return (
                <Paper style={{
                    padding: '1em',
                    width: '95%',
                    maxWidth: '700px',
                    minWidth: '200px',
                    marginBottom: '1em'
                }}>
                    <Typography component={'h6'} variant='h6'>{("Question " + this.props.index)}</Typography>
                    <Spacer />
                    <Typography fontWeight="bold">
                        {this.state.question}
                    </Typography>
                    {(!this.state.isOptional) && (<Typography variant='subtitle1' fontSize={'14px'} color={red[500]} sx={{
                        mt: 1,

                    }}>
                        Required
                    </Typography>)}


                    <Spacer space={10} />
                    {this._getBody()}

                    <Spacer space={10} />
                    <Divider />


                    <IconButton style={{
                        marginRight: '1em'
                    }} onClick={() => {
                        if (this.props.onRemove) { this.props.onRemove(this.props.index - 1) }
                    }}>
                        <DeleteIcon />
                    </IconButton>

                    <IconButton onClick={() => {
                        this.setState({
                            ...this.state,
                            isEditing: true
                        })
                    }}>
                        <EditIcon />
                    </IconButton>

                </Paper>
            )
        }

    }
}




const DefaltQuestionnaire: Questionnaire = {
    title: "No Title",
    createdBy: 0,
    createdAt: Date.now(),
    questions: [],
    isDefault: false,
    id: 0,
    updatedAt: Date.now()
}

const DefaultQuestion: Question = {
    id: 0,
    question: "Type in a question",
    placeholder: "No placeholder",
    answerType: "string",
    isMultiline: false,
    isOptional: false,
    createdAt: Date.now(),
    updatedAt: Date.now()

}

const QuestionnaireCreateUpdate: React.FC<{
    load: boolean;
}> = ({ load = false }) => {
    const dispatch = useDispatch();

    const [loading, setLoading] = useState(false)
    const [questionnaire, setQuestionnaire] = useState<Questionnaire>(DefaltQuestionnaire);
    const [sentinel, setSentinel] = useState(0);

    const [activeQuestion, setActiveQuestion] = useState(DefaultQuestion)
    const [changed, setChanged] = useState(false);
    const [questions, setQuestions] = useState<Question[]>([]);

    const currentQuestion = useRef<QuestionComponent | null>(null)
    const [currentIndex, setCurrentIndex] = useState(0);
    let { id } = useParams<{ id: string }>();

    useEffect(() => {
        if (id) check(parseInt(id))
        return () => {

        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id]);

    useEffect(() => {
        if (questions.length > 0) {
            setChanged(true)

            const box = document.querySelector('.content')
            if (box) {
                console.log(box)
                window.scrollTo(0, box.scrollHeight)

            }
        }

    }, [questions])


    useEffect(() => {
        setChanged(sentinel > 0)
    }, [sentinel])
    const save = async () => {
        setLoading(true)
        try {

            if (questionnaire.id < 1 && questions.length) {
                // let ans = await Api.Model.createModel<Questionnaire>('questionnaire', { ...questionnaire, questions });
                let ans = await Api.createModel<Questionnaire>({modelName: 'questionnaire',
               payload: { ...questionnaire, questions: questions.map((v, i) => ({
                ...v,
                sortIndex: i + 1

               })) }
            })
                console.log(ans);
                if(ans.errorData || ans.error) {
                    dispatch(putMessage({type: 'error', message: ans.errorData?.problems || ans.error || 'Something went wrong'}))
                }
                else {
                    queryClient.invalidateQueries(['load-questionnaires'])
                dispatch(putMessage({ type: 'success', message: 'Created successfully' }))
                }
                setChanged(false)

            }
            else if (questions.length) {
                // let ans = await Api.Model.updateModel<Questionnaire>("questionnaire", {
                //     id: questionnaire.id,

                // }, {
                //     isDefault: questionnaire.isDefault,
                //     title: questionnaire.title,
                //     questions: questions.map(v => ({ ...v, Questionnaire: questionnaire.id }))

                // })
                let ans =await Api.updateModel<Questionnaire>({
                    modelName: 'questionnaire',
                    where: {id: questionnaire.id},
                    
                    update: {
                            isDefault: questionnaire.isDefault,
                            title: questionnaire.title,
                            questions: questions.map((v) => ({ ...v, Questionnaire: questionnaire.id }))
        
                        }
                })
                if(ans.errorData || ans.error) {
                    dispatch(putMessage({type: 'error', message: ans.errorData?.problems || ans.error || 'Something went wrong'}))
                }else {
                    dispatch(putMessage({ type: 'success', message: 'Updated successfully' }))
                    queryClient.invalidateQueries(['load-questionnaire-' + questionnaire.id])
                }
                setChanged(false)
            }

        }

        catch (err: any) {
            console.error(err);
        }
        setLoading(false)
    }
    const check = async (modelId: number) => {
       
    
        const criteria: ViewRequest = {
            modelName: "questionnaire",
            modelId,
            populate: "questions",
          };
      let ans = await Api.viewModel<Questionnaire>(criteria);
      if (ans.code !== 200)  {
        console.log(ans);
        throw new Error("Cannot Load data");
      }
      return ans.data!.data.payload!;


 
  }
  const {isLoading, data, isFetching, isError, refetch} = useQuery('load-questionnaire-' + id || '-1',  () => check(parseInt(id || '-1', 10)), {enabled: load});

  useEffect(() => {
    if(!data) {
        return;
    }
    setQuestionnaire(data!);
    let ques = data!.questions.sort((a, b) => a.id - b.id);
    setQuestions(ques);
  }, [data])


    if (isLoading|| isFetching) {
        return <LoadingPageIndicator />
    }
    else if (isError) {
        return (
            <Box padding="0 1em" style={{
                maxWidth: '100vw'
            }}>

                <Alert severity="error" action={
                    <Button color="inherit" size="small" onClick={() => refetch}>
                        Retry
                    </Button>
                }>
                    An error occurred while loading
                </Alert>

            </Box>
        )
    }
    return (
        <Box id="questionnaire-box" padding="0 1em">
            {(changed) && (
                <Box sx={{
                    position: 'fixed', width: 100, height: 100,
                    bottom: -30,
                    right: -15,
                    zIndex: 9999
                }}>
                    <Fab
                        aria-label="save"
                        color="primary"
                        onClick={save}
                    >
                        <SaveIcon />
                    </Fab>
                    {loading && (
                        <CircularProgress
                            size={68}
                            sx={{
                                color: green[500],
                                position: 'absolute',
                                top: -6,
                                left: -6,
                                zIndex: 1,
                            }}
                        />
                    )}
                </Box>
            )}
            <div style={{

                width: '95%',
                maxWidth: '700px',
                minWidth: '200px',
                marginBottom: '1em'
            }}>
                <TextField value={questionnaire.title} onChange={(e) => {
                    setQuestionnaire({
                        ...questionnaire,
                        title: e.target.value
                    })
                    setSentinel(sentinel + 1)
                }} fullWidth label="Title" id="fullWidth" />
                <Spacer />
                <FormControlLabel control={<Checkbox checked={questionnaire.isDefault} onChange={(e, c) => {
                    setQuestionnaire({
                        ...questionnaire,
                        isDefault: c
                    })
                    setSentinel(sentinel + 1)
                }} ></Checkbox>} label="Use as default questionnaire" />
            </div>
            <Spacer />
            <Divider />

            <Typography component={'h6'} variant='h6'>Questions</Typography>
            <Spacer />

            {questions.map((q, index) => (
                <QuestionComponent key={'question-' + index} index={index + 1} question={q} onSelect={(v) => {
                    currentQuestion.current = v;
                    setCurrentIndex(index + 1)
                }}
                    selected={currentIndex === index + 1}

                    onSave={() => {
                        let qs = [...questions];
                        if (currentQuestion.current) {
                            let q = currentQuestion.current.getQuestion();
                            qs[q.index - 1] = q.question;
                            console.log(qs);
                            setQuestions(qs);

                        }
                    }}

                    onRemove={(i) => {
                        if (questions.length === 1) {
                            setQuestions([])
                            return;
                        }
                        let ans = removeFromIndex<Question>(questions, index);

                        setQuestions(ans)
                    }}
                />
            ))}

            <QuestionComponent ref={currentQuestion} question={activeQuestion} index={0} onSave={() => {
                console.log(currentQuestion.current)
                if (currentQuestion.current) {
                    let q = (currentQuestion.current.getQuestion())
                    setQuestions(questions.concat([q.question]));
                    let p: Question = { ...DefaultQuestion }
                    setActiveQuestion(p)
                    currentQuestion.current.reset(p);

                }
            }} onSelect={(v) => {
                currentQuestion.current = v;
                setCurrentIndex(0)
            }} selected={currentIndex === 0} />

            <Spacer />






        </Box>
    )
}

export default QuestionnaireCreateUpdate
